(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('audienceCtrl', ['$scope', '$stateParams', 'audiencesService', '$state', 'audiences', 'growlService', 'sweetAlertService', 'sharedDataService', 'profileHelper', function ($scope, $stateParams, audiencesService, $state, audiences, growlService, sweetAlertService, sharedDataService, profileHelper) {

            $scope.fromOptions = {
                showWeeks: false
            };

            $scope.toOptions = {
                showWeeks: false
            };


            $scope.allowOtherProperties = profileHelper.allowOtherProperties();
            $scope.profileSchemaMap = profileHelper.getSchema().map(function (singleSchema) {
                return singleSchema.path;
            });
            
            $scope.audiences = audiences;
            $scope.today = new Date();
            $scope.calendar = {
                created: {
                    to: {},
                    from: {}
                },
                changed: {
                    to: {},
                    from: {}
                }
            };
            $scope.users = [{ value: '', label: 'All users' }];
            if (audiences.length > 0) {
                audiences.forEach(function (audience) {
                    if ($scope.users.filter(
                        function (user) {
                            return audience._createdBy == user.value;
                        }).length === 0) {
                        $scope.users.push({ value: audience._createdBy, label: sharedDataService.getUsername(audience._createdBy) });
                    }
                });
            }
            $scope.getUsername = function (value) {
                if (!value || value.length === 0) {
                    return 'All users';
                } else {
                    return sharedDataService.getUsername(value);
                }

            };

            $scope.checkIfValid = function (audience) {
                if (!$scope.allowOtherProperties) {
                    var segments = audience.query.split('&');
                    var segmentsLen = segments.length;
                    segments = segments.filter(function (segment) {
                        return $scope.profileSchemaMap.includes(segment.split('=')[0]);
                    });
                    return segmentsLen == segments.length;
                }
                return true;
            };

            $scope.addCreatedBy = function (author) {
                $scope.createdBy = author;
            };

            $scope.delete = function (audience) {
                sweetAlertService.confirmationAlert(
                    "Are you sure?",
                    "You will not be able to recover this audience!",
                    "Yes, delete it!",
                    "No",
                    function (isConfirm) {
                        if (isConfirm) {
                            audiencesService.deleteAudience($stateParams.pickedApiSpaceId, encodeURIComponent(audience.id)).then(function (result) {
                                $scope.audiences.splice($scope.audiences.indexOf(audience), 1);
                            }).catch(function (error) {
                                growlService.danger("Audience wasn't deleted due to: " + error.statusText);
                            });
                        } else {
                            growlService.success("Audience wasn't deleted");
                        }

                    }
                );
            };
            $scope.open = function ($event, toOpen) {
                $event.preventDefault();
                $event.stopPropagation();
                toOpen.opened = !toOpen.opened;
            };
            $scope.pick = function (picked) {
                var params = $stateParams;
                params.criteria = picked.query;
                params.pickedCriteria = picked;
                $state.go('main.apiSpace.profiles.search', params);
            };
        }]);
})(window.angular);
